(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["metalbird-stockist-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

    document.querySelectorAll('[data-stockist-locator]').forEach((locator) => {
      const search = locator.querySelector('[data-stockist-search]');
      const region = locator.querySelector('[data-stockist-region]');
      const items = Array.from(locator.querySelectorAll('[data-stockist-item]'));
      const count = locator.querySelector('[data-stockist-count]');
      const empty = locator.querySelector('[data-stockist-empty]');
      const map = locator.querySelector('[data-stockist-map]');
      const caption = locator.querySelector('[data-map-caption]');
      const singular = locator.dataset.singular;
      const plural = locator.dataset.plural;

      const filterItems = () => {
        const term = normalize(search.value.trim());
        const selectedRegion = region.value;
        let visible = 0;

        items.forEach((item) => {
          const matchesTerm = !term || normalize(item.dataset.search).includes(term);
          const matchesRegion = !selectedRegion || item.dataset.region === selectedRegion;
          const show = matchesTerm && matchesRegion;
          item.hidden = !show;
          if (show) visible += 1;
        });

        count.textContent = `${visible} ${visible === 1 ? singular : plural}`;
        empty.hidden = visible !== 0;
      };

      search.addEventListener('input', filterItems);
      region.addEventListener('change', filterItems);

      locator.querySelectorAll('[data-map-query]').forEach((button) => {
        button.addEventListener('click', () => {
          items.forEach((item) => item.removeAttribute('aria-current'));
          button.closest('[data-stockist-item]').setAttribute('aria-current', 'true');
          map.src = `https://www.google.com/maps?q=${button.dataset.mapQuery}&output=embed`;
          map.title = button.dataset.mapName;
          caption.textContent = button.dataset.mapName;
          if (window.matchMedia('(max-width: 800px)').matches) {
            map.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });

      filterItems();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
